import { Badge, Box } from '@mui/material'
import React , { useEffect , useState } from 'react'
import { MedalsIcon } from 'Sui_Icons'
import { convertToPersianNumber } from 'utils'
import useHttp from 'hooks/use-http'

export const Medals = ({infoUser}) => {

    const [info , setInfo ] = useState({});
    const { sendRequest: fetchInfo } = useHttp();

    useEffect(() => {
        const getToken = ({ data }) => {
            console.log(data.user[0]);
            setInfo(data.user[0]);
        };
        fetchInfo({ url: "/home/info" }, getToken);
    }, [fetchInfo]);

    const numberOfMedals = 2
    return (
        <Box sx={{ cursor: 'pointer' }}>
            <Badge
                //badgeContent={convertToPersianNumber(info?.trophy)}
                badgeContent={convertToPersianNumber(infoUser?.trophy)}
                color='white'
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }} >
                <MedalsIcon size={'40px'} sx={{ filter: 'drop-shadow(0px 18px 9px rgba(255, 191, 95, 0.19))' }} />
            </Badge>
        </Box>
    )
}
